export default "__VITE_ASSET__DTBTVNkT__"